import { helpers } from '../helpers.js';

var block_video = {
  options: {
    // global options
  },

  selectors: {
    button: ".js-block-video-play-button",
    stopButton: ".js-block-video-stop-button"
  },

  init: function () {
    const self = this;

    self.loadFunctionInside();
    self.embed();
  },

  embed: function() {
    const self = this;

      jQuery( '[data-play-vimeo]' ).on( 'click', function () {
        self.playVideo( 'vimeo', jQuery( this ).attr( 'data-play-vimeo' ) );
      });
      
      jQuery( '[data-pause-vimeo]' ).on( 'click', function () {
        self.pauseVideo( 'vimeo', jQuery( this ).attr( 'data-pause-vimeo' ) );
      });
  },

    playVideo: function(type, id) {
      let videoBox = document.querySelector('#' + id);
      videoBox.parentElement.parentElement.classList.add('is-playing');

      if (type == 'video') {
        videoBox.play();
        videoBox.parentElement.parentElement.classList.add('is-playing');
      } else if (type == 'vimeo') {
        var player = new Vimeo.Player(videoBox); // new Vimeo.Player == Froogaloop
        player.play();
      }
    },

     pauseVideo: function(type, id) {
      let videoBox = document.querySelector('#' + id);
      videoBox.parentElement.parentElement.classList.remove('is-playing');

      if (type == 'video') {
        videoBox.pause();
      } else if (type == 'vimeo') {
        var player = new Vimeo.Player(videoBox); // new Vimeo.Player == Froogaloop
        player.pause();
      }
    },

  loadFunctionInside: function () {
    const self = this;

    jQuery(self.selectors.button).each(function() {
      var $btn = jQuery(this);
      var videoId = $btn.data('video-id');

      if (!videoId) return;

      var $video = jQuery('#' + videoId);
      if ($video.length === 0) return;

      var video = $video.get(0);

      $btn.on('click', function(e) {
        e.preventDefault();
        video.play();
        $btn.hide();
      });

      $video.on('pause ended', function() {
        $btn.show();
      });

      $video.on('play', function() {
        $btn.hide();
      });

      // STOP BUTTON
      $video.on('click', function(e) {
        e.preventDefault();
        video.pause();
        $btn.show();
      });
    });
  }
}

// Export
export { block_video };